import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { Table } from 'primeng/table';
import { MasterDTO } from '../../model/admin.entity';
import { CommonService } from '../../../core/common/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { CertificateTypeDTO } from '../../model/certificate-type.entity';
import { Router } from '@angular/router';
import { MasterDataRepository } from '../../../core/data/repositories/masterdata.repository';

@Component({
  selector: 'tandc-certificate-type',
  templateUrl: './certificate-type.component.html',

})
export class CertificateTypeComponent implements OnInit {

  showModal: boolean = false;
  certificateTypeList: CertificateTypeDTO[] = [];
  modal: CertificateTypeDTO = new CertificateTypeDTO();
  modalTitle: string = "";
  @ViewChild('dt')
  dt!: Table;
  model: CertificateTypeDTO = new CertificateTypeDTO();
	certificateType: CertificateTypeDTO = new CertificateTypeDTO();

  constructor(private service: AdminService,
    private commonService: CommonService,
    private translate: TranslateService,
    private router: Router,
    private masterDataRepository: MasterDataRepository) { }

  ngOnInit(): void {
    this.getAll();
  }

  applyFilterGlobal($event: any, stringVal: any) {
    this.dt!.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  getAll() {
    this.service.getCerType().subscribe((x) => {
      this.certificateTypeList = x.value;
      console.log(x);
    })
  }

  addModal() {
    this.router.navigate(['admin/certificateTypeStandard']);
    this.modalTitle =this.translate.instant('commonbtn.add') + ' ' + this.translate.instant('certificate.type')
  }

  delete(data: CertificateTypeDTO) {
    this.commonService.confirmationService.confirm({
      message: this.translate.instant('Alerts.DeleteConfirmation'),
      accept: () => {
        if (data) {
          this.service
            .deleteCertificateType(data.id)
            .subscribe((res) => {
              if (res) {
                this.commonService.successMessage(
                  this.translate.instant('Alerts.DeleteSuccessfully')
                );
                this.getAll();
              }
            });
        }
      }
    });
  }

  edit(data: CertificateTypeDTO) {
    this.showModal = true
    //this.router.navigate(['admin/certificateTypeStandard', data.id]);
    this.modalTitle=this.translate.instant('common.update') + ' ' + this.translate.instant('Master.certificateType')
    this.model = data;
    // this.showModal = !this.showModal;
  }

  cancel() {
    this.showModal = false;
  }

  save(data: CertificateTypeDTO) {
    if (data.id > 0) {
      this.service.updateCertificateType(data).subscribe((res: any) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.UpdatedSuccessfully')
          );
          this.router.navigate(['admin/certificatetype']);
          this.getAll();
        }
      })
    }
    else {
      this.service.saveCertificateType(data).subscribe((res: any) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.SavedSuccessfully')
          );
          this.router.navigate(['admin/certificatetype']);
          this.getAll();
        }
      });
    }
  }

  onToggleStatus(item: MasterDTO) {
  const updatedItem = { ...item }; 
  this.service.updateCertificateType(updatedItem).subscribe({
    next: () => {
      this.commonService.successMessage(
        this.translate.instant('Alerts.UpdatedSuccessfully')
      );
    },
    error: () => {
      this.commonService.errorMessage(
        this.translate.instant('Alerts.ErrorOccured')
      );
      // Revert toggle on error
      item.isActive = !item.isActive;
    }
  });
  }

  downloadFile(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  export() {
    this.masterDataRepository.export('certificate-type').subscribe(blob => {
      this.downloadFile(blob, `certificate-type-${new Date().toISOString().slice(0,10)}.xlsx`);
    });
  }
}
